import { createLookupStore, type LookupStore } from '@botto/core';
import { smsClient } from '../api/client';
import type { components } from '../api/generated/schema';

export type SmppHost = components['schemas']['SmppHostResponseSchemaLenient'];

let _smppHosts: LookupStore<SmppHost> | undefined;

async function fetchAllSmppHosts(): Promise<SmppHost[]> {
  const { data, error } = await smsClient.GET('/smpp_hosts/', {
    params: {
      query: {
        offset: 0,
        limit: 1000,
        'sort.name': 'name',
        'sort.direction': 'asc',
      },
    },
  });
  if (error) throw error;
  return data?.items ?? [];
}

export function getSmppHostsLookup(): LookupStore<SmppHost> {
  if (!_smppHosts) {
    _smppHosts = createLookupStore<SmppHost>(fetchAllSmppHosts, {
      idField: 'smpp_host',
      labelField: 'name',
      format: (h) => `${h.name ?? ''} (${h.description ?? ''})`,
    });
  }
  return _smppHosts;
}
